<app-content-body [isCentralized]='false' height='90vh'>



    <div class="container-fluid px-xl-5 px-0 pt-5 mt-3 card-scrollable">
        <div class="row">
            <div class="col">
                <h1 class="fw-bold fs-2">NCache Cloud Portal</h1>
            </div>
        </div>
        <div class="row row-cols-2 g-2 g-lg-5">
            <div class="col mb-3">
				<p>You must subscribe to NCache Cloud offering from Azure / AWS Marketplaces before using NCache Cloud Portal here.</p>

                <div class="row">
                    <div class="col-sm-6 mb-3 mb-sm-0">
                      <div class="card p-2  border-light-subtle">
                        <div class="card-body">
                              <div class="mb-2">
                                <!-- <fa-icon class="me-1" [icon]="faPlus"></fa-icon> -->

                                  <i class="bi bi-cloud-download fs-2"></i>
                              </div>
                          <h5 class="card-title">Azure Marketplace</h5>
                          <p class="card-text">NCache Cloud</p>
                              <p class="card-text text-secondary">Click on the link below to subscribe to Azure Marketplace if you haven't already done so.</p>
                          <a href="https://portal.azure.com/#view/Microsoft_Azure_Marketplace/GalleryItemDetailsBladeNopdl/id/ncache.ncache-cloud/selectionMode~/false/resourceGroupId//resourceGroupLocation//dontDiscardJourney~/false/selectedMenuId/home/launchingContext~/%7B%22galleryItemId%22%3A%22ncache.ncache-cloudncache_cloud%22%2C%22source%22%3A%5B%22GalleryFeaturedMenuItemPart%22%2C%22VirtualizedTileDetails%22%5D%2C%22menuItemId%22%3A%22home%22%2C%22subMenuItemId%22%3A%22Search%20results%22%2C%22telemetryId%22%3A%22f8df0765-3c2f-4302-91d3-aa19ea8778cb%22%7D/searchTelemetryId/6b68fc5a-27de-4587-a752-f61639b2508e" target="ncentclazure" class="btn btn-primary">Subscribe</a>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="card p-2  border-light-subtle">
                        <div class="card-body">
                              <div class="mb-2">
                                  <i class="bi bi-amazon fs-2"></i>
                              </div>
                          <h5 class="card-title">AWS Marketplace</h5>
                          <p class="card-text">NCache Cloud</p>
                              <p class="card-text text-secondary">Click on the link below to subscribe to AWS Marketplace if you haven't already done so.</p>
                          <a href="https://aws.amazon.com/marketplace/pp/prodview-l64kkzi2b2xdc" target="ncentclawsy" class="btn btn-primary me-3 aws-annual-link">Subscribe</a>
                        </div>
                      </div>
                    </div>
                  </div>
            </div>


            <div class="col mb-3">
				<div class="card p-2 bg-light ">
					<div class="card-body">
						<div class="mb-2">
							<img src="https://www.alachisoft.com/images/logo-d.svg" alt="NCache" class="img-fluid mb-3 logoheight-cloud">
						</div>
						<p class="card-text fw-medium">Sign in to continue to NCache Cloud</p>

                <form [formGroup]="formEmailAndPasswordGroup" (ngSubmit)="onSubmitEmailAndPassword()">
                    <div class="mb-3">
                        <label for="exampleInputEmail1" class="form-label">Email address</label>
                        <input tabindex="0"  #exampleInputEmail1  appAutoFocus type="email" maxlength="128" formControlName="email" class="form-control"  id="exampleInputEmail1" style="font-size: 14px;" aria-describedby="emailHelp" placeholder="Enter Email" appAutoFocus placeholder="Enter Email" [ngClass]="{ 'is-invalid': emailAndPasswordFormSubmitted && emailAndPasswordForm.email.errors }">
                        <div *ngIf="emailAndPasswordFormSubmitted && emailAndPasswordForm.email.errors" class="invalid-feedback">
                            <div *ngIf="emailAndPasswordForm.email.errors.required">Email is required</div>
                            <div *ngIf="emailAndPasswordForm.email.errors.email">Email is invalid</div>
                        </div>
                        <div id="emailHelp" class="form-text">We'll never share your email with anyone else.</div>
                    </div>
                    <div class="mb-3">
                        <label for="exampleInputPassword1" class="form-label">Password</label>
                        <input
                        [type]="passwordShow ? 'text' : 'password'"
                        formControlName="password"
                        class="form-control "
                        style="font-size: 14px;"
                        placeholder="Password"
                        id="exampleInputPassword1"
                        [ngClass]="{ 'is-invalid': (emailAndPasswordFormSubmitted && emailAndPasswordForm.password.errors)  }">

                        <div *ngIf="emailAndPasswordFormSubmitted && emailAndPasswordForm.password.errors" class="invalid-feedback">
                            <div *ngIf="emailAndPasswordForm.password.errors.required">Password is required</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" id="exampleCheck1" (click)="onPasswordShowClick('passwordShow')">
                          <label class="form-check-label" for="exampleCheck1">Show Password</label>
                        </div>
                        <a routerLink="" (click)="navigateToForgotPassword()" class="d-block mt-1">Forgot Password?</a>
                      </div>

                    <button type="submit" class="btn btn-primary">Submit</button>
                    </form>
				</div>
			</div>
		</div>

            <!-- <div class="col-auto">

                <div class="border rounded shadow-sm p-4 d-block bg-white">

                    <div class="container" *ngIf="!email_exists">

                        <img class="img-fluid mb-4 logoheight" src="https://www.alachisoft.com/images/logo-d.svg"
                            alt="NCache" />
                        <h2 class="passowrdlabel">Sign in</h2>

                        <p class="form-text text-muted">to continue to
                            NCache Cloud <fa-icon *ngIf='loginHeading == "Register"' [icon]='faQuestionCircle'
                                class="question-circle" placement="right"
                                ngbTooltip="Please use the same email address that you subscribed with"></fa-icon>
                        </p>

                        <form [formGroup]="formEmailGroup" (ngSubmit)="this.onSubmitEmail()">

                            <div class="form-group">
                                <input autofocus type="email" formControlName="email" class="form-control form-control-sm email-sm" style="font-size: 14px;" aria-describedby="emailHelp" placeholder="Enter Email" appAutoFocus placeholder="Enter Email" [ngClass]="{ 'is-invalid': emailFormSubmitted && emailForm.email.errors }" />
                                <div *ngIf="emailFormSubmitted && emailForm.email.errors" class="invalid-feedback">
                                    <div *ngIf="emailForm.email.errors.required">Email is required</div>
                                    <div *ngIf="emailForm.email.errors.email">Email is invalid</div>

                                </div>
                            </div>

                            <button [disabled]="this.isEmailVerificationLoading" class="btn btn-primary btn-sm mt-3 float-end px-3">
                                <span *ngIf="this.isEmailVerificationLoading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                <span [class.ms-2]="this.isEmailVerificationLoading">Next</span>
                            </button>

                        </form>
                    </div>

                    <div class="container" *ngIf="email_exists">

                        <img class="img-fluid mb-4 logoheight" src="https://www.alachisoft.com/images/logo-d.svg" alt="NCache" />
                        <form [formGroup]="formPasswordGroup" (ngSubmit)="this.onSubmitPassword()">

                                <div
                                class="d-flex flex-row align-items-center gap-3"
                                style="cursor: pointer; transition: background-color 0.3s;"
                                >
                                <fa-icon
                                    [icon]="faArrowLeft"
                                    (click)="backToEmailForm()"
                                    class="text-primary"
                                    style="font-size: 1.5rem; transition: transform 0.3s;"

                                ></fa-icon>

                                <div>
                                    <label
                                    class="email-label fw-bold text-secondary"
                                    style="font-size: 1rem;"
                                    for="email"
                                    >
                                    {{ this.emailForm.email.value }}
                                    </label>
                                </div>
                            </div>


                            <div class="form-group mb-2">

                                <h3 class="passowrdlabel mb-4">Enter Password</h3>

                                <div class="input-group">

                                    <input
                                        #passwordField
                                        id="passwordForm"
                                        [type]="passwordShow ? 'text' : 'password'"
                                        class="inputpassword"
                                        formControlName="password"
                                        class="form-control form-control-sm"
                                        placeholder="Password"
                                        [ngClass]="{ 'is-invalid': (passwordFormSubmitted && passwordForm.password.errors) || incorrect_password  }"
                                    />

                                    <span class="input-group-text pointer eye-parent" (click)="onPasswordShowClick('passwordShow')">
                                        <fa-icon class="eye-icon" [icon]="passwordShow ? faEye : faEyeSlash"></fa-icon>
                                    </span>

                                </div>

                                <div *ngIf="this.passwordFormSubmitted && passwordForm.password.errors"  style="color: red;" >
                                    <div *ngIf="passwordForm.password.errors.required">Password is required</div>
                                </div>
                                <div *ngIf="incorrect_password && !this.passwordFormSubmitted" style="color: red;" >
                                    <div>Password is incorrect</div>
                                </div>
                            </div>

                            <a routerLink="" (click)="navigateToForgotPassword()">Forgot Password?</a>

                            <br>

                            <button [disabled]="isPasswordVerificationLoading" class="btn btn-primary mt-2 float-end">
                                <span *ngIf="isPasswordVerificationLoading" class="spinner-border spinner-border-sm me-1"></span>
                                Sign in
                            </button>

                        </form>
                    </div>

                    <p class="d-none"><small class="form-text text-muted">New User? <a href="#">Register now!</a></small></p>

                    <div class="clearfix"></div>

                </div>
            </div> -->
        </div>
        </div>

</app-content-body>

<ng-template #verificationOTPModal let-modal>
    <div>
        <h4 class="fw-bold p-4 m-0">Verify Email Address</h4>
        <hr class="m-0">
        <div class="p-4">
            <p style="font-size: 1rem;" class="m-0">A verification OTP has been emailed to <span class="text-blue">{{ this.verificationEmail }}</span>.<br> Please enter it below to proceed.</p>
            <p style="font-size: 1rem;" class="m-0 mt-2">Haven’t received an email?
                <button [disabled]="otpCounter == 0 ? '' : 'disabled'" class="d-inline btn btn-link border-0 p-0" style="font-size: 0.9rem;" (click)="resendOTP()">
                    Resend OTP
                    <span *ngIf="resendOtpLoading" class="spinner-border spinner-border-sm ms-2"></span>
                    <fa-icon class="ms-2" [icon]="faCheckCircle" *ngIf="resendSuccessful" size="lg" style="color: green;"></fa-icon>
                </button>
            </p>
            <p *ngIf="otpCounter !== 0" style="font-size: 1rem;" class="m-0 mt-1">You can resend OTP after {{ otpCounter }} seconds.</p>
        </div>
        <hr class="m-0">
        <div class="d-flex p-4">
            <input class="flex-fill" type="text" (input)="verificationOTPConsentChange($event.target.value)">
            <button class="btn btn-sm btn-primary ms-3 px-3" [attr.disabled]="otpVerifyDisabled ? true : null" (click)="verifyOTP()">
                <span style="visibility: hidden;">a</span>
                <span *ngIf="verifyOtpLoading" class="spinner-border spinner-border-sm me-1"></span>
                Verify
                <span style="visibility: hidden;">a</span>
            </button>
            <button class="btn btn-sm btn-outline-primary ms-3 px-3" (click)="closeModal()">Cancel</button>
        </div>
    </div>
</ng-template>

<footer class="footer bg-transparent">
    &copy; <span>{{getProjectVersionAndName()}}</span>
</footer>

